/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Flow_ExplorerInputs */

const en_nav_flow_explorer = /** @type {(inputs: Nav_Flow_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flow Explorer`)
};

const es_nav_flow_explorer = /** @type {(inputs: Nav_Flow_ExplorerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorador de flujo`)
};

/**
* | output |
* | --- |
* | "Flow Explorer" |
*
* @param {Nav_Flow_ExplorerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_flow_explorer = /** @type {((inputs?: Nav_Flow_ExplorerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Flow_ExplorerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_flow_explorer(inputs)
	return es_nav_flow_explorer(inputs)
});